import { BrandCaptionLowerThirdEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdUseRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdUseRequestDTO.validationSchema(),
    BrandCaptionLowerThirdEntity
  );

  constructor(readonly data: RoomBrandCaptionLowerThirdUseRequest) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdUseRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "caption"],
      properties: {
        roomId,
        caption: {
          instanceof: BrandCaptionLowerThirdEntity.name
        }
      }
    };
  }
}

interface RoomBrandCaptionLowerThirdUseRequest {
  roomId: RoomId;
  caption: BrandCaptionLowerThirdEntity;
}
